<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-domain"
          :title="
            id
              ? $i18n.t('Edit Holiday Configuration - ') + holiday.name
              : $i18n.t('Create Holiday Configuration - ') + holiday.name
          "
          class="px-3 py-1 small-icon"
        >
          <v-form id="form" v-model="isValid">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-container class="py-0">
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="3">
                      <v-text-field
                        :label="$i18n.t('Name')"
                        v-model="holiday.name"
                        :rules="validationrules.name"
                        maxlength="25"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <v-text-field
                        :label="$i18n.t('Description')"
                        class="purple-input"
                        v-model="holiday.description"
                        :rules="validationrules.desc"
                        maxlength="50"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <v-text-field
                        :label="$i18n.t('Year')"
                        class="purple-input"
                        v-model="holiday.year"
                        :rules="validationrules.year"
                        maxlength="4"
                        type="number"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" lg="3">
                      <z-country-select
                        class="purple-input"
                        v-model="holiday.country"
                        :rules="validationrules.country"
                        required
                      ></z-country-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-container class="py-0">
                  <v-card>
                    <v-simple-table dense style="padding: 10px">
                      <thead>
                        <tr>
                          <th class="primary--text">{{ $i18n.t("Holiday") }}</th>
                          <th class="primary--text">{{ $i18n.t("Date") }}</th>
                          <th class="primary--text">{{ $i18n.t("Optional") }}</th>
                          <th class="text-right primary--text"></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(holiday, index) in holiday.holidays" :key="holiday._id">
                          <td>
                            <v-text-field
                              :label="$i18n.t('Name')"
                              class="purple-input"
                              v-model="holiday.name"
                              :rules="validationrules.name"
                              maxlength="20"
                              required
                            ></v-text-field>
                          </td>
                          <td>
                            <z-date-picker
                              v-model="holiday.date"
                              :rules="validationrules.date"
                              required
                            />
                          </td>
                          <td>
                            <v-checkbox v-model="holiday.optional"></v-checkbox>
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(index)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                  <v-col>
                    <v-btn small class="float-right" color="blue" @click="add()">
                      <v-icon>mdi-plus</v-icon>
                      {{ $i18n.t("Add Holiday") }}
                    </v-btn>
                  </v-col>
                </v-container>
              </v-col>
            </v-row>
            <v-row style="padding: 0 20px">
              <v-btn small fab :to="'/holidays'">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class HolidayEdit extends Vue {
  isValid = true;
  holiday = {
    _id: null,
    name: "",
    description: "",
    year: "",
    country: "",
    holidays: [],
  };

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    desc: [(v) => !!v || this.$i18n.t("Description is required")],
    year: [(v) => !!v || this.$i18n.t("Year is required")],
    date: [(v) => !!v || this.$i18n.t("Date is required")],
    country: [(v) => !!v || this.$i18n.t("Country is required")],
  };

  id = null;

  get loading() {
    return common.loading;
  }

  remove(_index) {
    this.holiday.holidays.splice(_index, 1);
  }

  add() {
    if (this.holiday.holidays == null) {
      this.holiday.holidays = [];
    }
    this.holiday.holidays.push({
      _id: null,
      name: "",
      description: "",
      year: "",
      country: "",
      holidays: [],
    });
  }

  createNew() {
    window.location.href = "/holiday/create";
  }

  async save() {
    try {
      common.setLoading(true);
      this.holiday = await doPost("/api/holiday/group/save", this.holiday);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      window.location.href = "/holiday/" + this.holiday._id;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.holiday = await doGet("/api/holiday/group/" + id + "/get");
      if (this.holiday._id != null) {
        this.id = this.holiday._id;
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>
